import axios from 'axios';
import {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import Loading from '../../common/Loading';
import LoadListListItem from "../LoadList/LoadListListItem";
import LoadListDetailsOwnershipAssignedToDisplay from './LoadListDetailsOwnershipAssignedToDisplay';
import LoadListDetailsOwnershipContractToDisplay from './LoadListDetailsOwnershipContractToDisplay';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function LoadListDetailsOwnershipEdit(props) {
    console.debug('RTS Break LoadListDetailsOwnershipEdit');

    const history = useNavigate();

    const {userAuthToken, apiRoot} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle, setErrorTitle] = useState("Validation Error");
    
    const [assignedToLink, setAssignedToLink] = useState();
    const [contractToLink, setContractToLink] = useState();


    useEffect(() => {
        setAssignedToLink(props.data.assignedToLink);
        setContractToLink(props.data.contractToLink)
        setIsLoading(false);
    }, [props.data.assignedToLink, props.data.contractToLink]); 


    function handleSubmit(e) {
        e.preventDefault();

        let apiObj = props.data;
        apiObj.assignedToLink = assignedToLink;
        apiObj.contractToLink = contractToLink;

        let apiURL = apiRoot + "/Loads/UpdateLoad/" + apiObj.idGuid;
        axios
        .put(
            apiURL,
            apiObj, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            window.scrollTo(0,0);
            history(-1);
        })
        .catch(error => {
            setErrorTitle("Update Error");
            setErrorBody("An error has occured.  Please review the console log for details.");
            console.log("RTS UpdateLoad Error", error);
            setShowErrorModal(true);
        });
    } 


    function setAssignedToLinkVal(pLinkVal, pCustomerVal){
        setAssignedToLink(pLinkVal);
        setContractToLink(null);
        props.setFormDirtyFx(1);
    } 
    

    function setContractToLinkVal(pVal){
        setContractToLink(pVal);
        props.setFormDirtyFx(1);
    }    


    if(isLoading){
        return(
            <Loading />
        );
    }


    return (
        <Box>
            <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
                <DialogTitle>{errorTitle}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{errorBody}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
                </DialogActions>
            </Dialog>
            <Box>
                <LoadListListItem data={props.data} user={props.user} hideLinks={true}/>
            </Box>
            <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', pt:2}}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                <form onSubmit={handleSubmit} style={{width:'400px'}}>
                    <Box>
                        <Typography variant='h6'>Sold To: {props.data.soldToCustomer.name}</Typography>
                    </Box>

                    <LoadListDetailsOwnershipAssignedToDisplay 
                        data={props.data}
                        setAssignedToLinkFx={setAssignedToLinkVal} 
                        setFormDirtyFx={props.setFormDirtyFx} 
                    />

                    <LoadListDetailsOwnershipContractToDisplay 
                        data={props.data} 
                        contractToLink={contractToLink}
                        setContractToLinkFx={setContractToLinkVal}
                        setFormDirtyFx={props.setFormDirtyFx} 
                    />                    


                    <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', pt:2}}>
                        <Box xs={{display:'flex'}}>
                            <Button type="submit"  disabled={props.formDirty===1?false:true} variant="contained" sx={{mr:2}}>Change Ownership</Button>
                        </Box>
                    </Box>
                </form>
                </LocalizationProvider>
            </Box>
        </Box>
    );

}
